import React, { useEffect, useState } from 'react';
import { closeModal, showModal } from 'lib/components/Modal';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import './index.scss';
import GameBaseDialog from 'lib/components/GameBaseDialog';

const OrderCompleteV2 = ({ packageName, priceDesc }) => {
  const [isOrdering, setIsOrdering] = useState(true);

  useEffect(() => {
    let timer = window.setTimeout(() => {
      report(ATTA_REPORT.SUBMIT_SUCCESS.REQ);
      setIsOrdering(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
      timer = 0;
    };
  }, []);

  const receiveGift = () => {
    report(ATTA_REPORT.SUBMIT_SUCCESS.CLICK);
    // 触发领奖
    location.reload();
  };
  const closeCallback = () => {
    closeModal();
    location.reload();
  };

  return isOrdering ? (
    <GameBaseDialog
      confirmButtonText={''}
      confirmCallback={receiveGift}
      showConfirm={false}
      showCancel={false}
      showClose={false}
      landscapeBg="https://act.ecovision.gtimg.com/static/imgs/static/static_1751778857562.png"
      backgroudImg="https://act.ecovision.gtimg.com/static/imgs/static/static_1751614694715.png"
    >
      <div className="order-complete">
        <div className="order-complete__text">{'验证码提交中...'}</div>
        <div className="order-complete__loading">
          <div className="loading-progress"></div>
        </div>
      </div>
    </GameBaseDialog>
  ) : (
    <GameBaseDialog
      customClass="order-complete-dialog"
      showCancel={false}
      title={`${packageName} 订购已提交`}
      footerType={'long-confirm'}
      confirmButtonText={'立即领奖'}
      confirmCallback={receiveGift}
      closeCallback={closeCallback}
      landscapeBg="https://act.ecovision.gtimg.com/static/imgs/static/static_1751778857562.png"
      backgroudImg="https://act.ecovision.gtimg.com/static/imgs/static/static_1751611036848.png"
    >
      <div className="order-complete">
        <div className="order-complete__done">
          <div className="order-complete__done--item">
            <div className="order-title">业务资费：</div>
            <div className="order-desc">{priceDesc}</div>
          </div>
          <div className="order-complete__done--item">
            <div className="order-title">生效时间：</div>
            <div className="order-desc">具体生效状态以运营商短信为准，生效后请重新登录客户端享受免流服务</div>
          </div>
          <div className="order-complete__done--item">
            <div className="order-title">领奖说明：</div>
            <div className="order-desc highlight">
              订购生效后需手动领取对应游戏权益，请前往页面下方点击立即领取按钮领取权益
            </div>
          </div>
          <div className="order-complete__done--tips">页面下方可能有多个领奖模块，请耐心拉到最底部哦</div>
        </div>
      </div>
    </GameBaseDialog>
  );
};

export const showOrderComplete = (props) => showModal(<OrderCompleteV2 {...props} />);

export default OrderCompleteV2;
